import { Project } from "@/types/projects.types";
import * as Yup from "yup";

export const projectDetailsValidationSchema = Yup.object<Project>().shape({
  name: Yup.string().required("Le nom est requis"),
  description: Yup.string().required("La description est requise"),
});
